// extracted by mini-css-extract-plugin
export var animationContainer = "_e2-0";
export var asteriskIcon = "_e2-8";
export var conversationLeftSection = "_e2-4";
export var conversationListItem = "_e2-3";
export var conversationMiddleSection = "_e2-5";
export var conversationRightSection = "_e2-6";
export var detailsContent = "_e2-1";
export var listContainer = "_e2-7";
export var modalContent = "_e2-2";